import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../../../store/actions/index'
import Button from '../../../../../components/UI/Button/Button'
import Gantt from '../../../../../components/GanttChart/GanttChart'
import Spinner from '../../../../../components/UI/Spinner/Spinner'
import InputGroup from '../../../../../components/UI/Forms/InputGroup/InputGroup'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Grid from '@material-ui/core/Grid'
import Checkbox from '@material-ui/core/Checkbox'
import RefreshIcon from '@material-ui/icons/Refresh'
import { withTranslate } from 'react-redux-multilingual'
import moment from 'moment'
class ActionPlan extends Component {
  state = {
    plan: [],
    planTemplate: [
      'task_name',
      'plan_start_date',
      'plan_end_date',
      'actual_start_date',
      'actual_end_date',
      'phase_name',
      'name',
      'completed_percent'
    ],
    newTask: {
      task_name: null,
      actual_start_date: moment(new Date()).format('YYYY-MM-DD'),
      actual_end_date: moment(new Date()).format('YYYY-MM-DD'),
      plan_start_date: moment(new Date()).format('YYYY-MM-DD'),
      plan_end_date: moment(new Date()).format('YYYY-MM-DD'),
      phase_name: null,
      name: null,
      completed_percent: null
    },
    addPlan: [],
    editPlan: [],
    data: null,
    gantt: { rows: {}, items: {} },
    add: false,
    edit: false,
    check: [],
    responsible: [],
    select: [],
    modalOpen: false,
    headerGantt: {
      label: {
        id: 'label',
        data: 'label',
        width: 100,
        // expander: true,
        header: {
          content: this.props.translate('task')
        }
      },
      responsible: {
        id: 'responsible',
        data: 'responsible',
        width: 250,
        // expander: true,
        header: {
          content: this.props.translate('responsible')
        }
      },
      progress: {
        id: 'progress',
        data: 'progress',
        width: 50,
        header: {
          content: '%'
        }
      }
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let update = { ...state }
    if (!props.loadingRes && props.actionPlan !== state.data) {
      let check = []
      let plan = props.actionPlan?.plan
      if (props.actionPlan?.plan) {
        check = props.actionPlan?.plan
        check = check.map(() => false)
        plan = plan.map(item => {
          let label = props.responsible.find(res => +res.emp_detail_id === +item?.emp_detail_id)
          return {
            ...item,
            name: item?.emp_detail_id
              ? label
                ? {
                    value: item.emp_detail_id,
                    label: `${label?.full_name || ''} (${label.org_abbr}) ${label.position_name}`,
                    name: label?.full_name || '',
                    position_name: `(${label.org_abbr}) ${label.position_name}`
                  }
                : {
                    value: item.emp_detail_id,
                    label: `${item?.emp_name || ''} (${''}) ${''}`,
                    name: item?.emp_name || '',
                    position_name: `(${''}) ${''}`
                  }
              : null
          }
        })
      }

      update = {
        ...update,
        data: props.actionPlan,
        plan: plan,
        check: check
      }
    }
    if (props.responsible !== state.responsible) {
      let responsible = props.responsible
      let select = responsible.map(item => {
        return {
          value: item.emp_detail_id,
          label: `${item.full_name} (${item.org_abbr}) ${item.position_name}`,
          name: item.full_name,
          position_name: `(${item.org_abbr}) ${item.position_name}`
        }
      })
      update = {
        ...update,
        responsible: responsible,
        select: select
      }
    }
    return update
  }
  componentDidMount = () => {
    this.props.fetchResponsibleOptionsForAppraisal({
      appraisal_type_id: this.props?.appraisalInfo.appraisal_type_id,
      company_id: this.props?.appraisalInfo.company_id
    })
    this.props.fetchActionPlan({
      result_id: this.props?.resultId,
      result_item_id: this.props?.resultItemId
    })
  }
  // componentDidUpdate = (prevProps, prevState) => {
  //   if (prevProps.success !== this.props.success) {
  //     // this.props.setData(this.props.actionPlan)
  //   }
  // }
  createData = (name, calories, fat, carbs, protein) => {
    return { name, calories, fat, carbs, protein }
  }
  inputChanged = (key, e, type) => {
    let task = null
    if (type === 'datePicker') {
      task = { ...this.state.newTask, [key]: moment(e).format('YYYY-MM-DD') }
    } else if (type === 'newselect') {
      task = { ...this.state.newTask, [key]: e }
    } else {
      task = { ...this.state.newTask, [key]: e.target?.value }
    }
    this.setState({
      newTask: task
    })
  }
  inputAllChanged = (key, e, type, i) => {
    let plan = this.state.editPlan
    if (type === 'datePicker') {
      plan[i] = { ...plan[i], [key]: moment(e).format('YYYY-MM-DD') }
    } else if (type === 'newselect') {
      plan[i] = { ...plan[i], [key]: e }
    } else {
      plan[i] = { ...plan[i], [key]: e.target?.value }
    }
    this.setState({
      editPlan: plan
    })
  }
  inputAddChanged = (key, e, type, i) => {
    let plan = this.state.addPlan
    if (type === 'datePicker') {
      plan[i] = { ...plan[i], [key]: moment(e).format('YYYY-MM-DD') }
    } else if (type === 'newselect') {
      plan[i] = { ...plan[i], [key]: e }
    } else {
      plan[i] = { ...plan[i], [key]: e.target?.value }
    }
    this.setState({
      addPlan: plan
    })
  }
  validateSave = () => {
    let check = false
    if (this.state.add) {
      let addPlan = this.state.addPlan
      addPlan.map(item => {
        check = check || item.task_name === null || item.task_name === ''
        return item
      })
    } else if (this.state.edit) {
      let editPlan = this.state.editPlan
      editPlan.map(item => {
        check = check || item.task_name === null || item.task_name === ''
        return item
      })
    }
    return check
  }
  // addTask = () => {
  //   let plan = this.state.plan
  //   plan.push(this.state.newTask)
  //   let check = this.state.check
  //   check.push(false)
  //   this.setState({
  //     add: false,
  //     newTask: {
  //       task_name: null,
  //       actual_start_date: moment(new Date()).format('YYYY-MM-DD'),
  //       actual_end_date: moment(new Date()).format('YYYY-MM-DD'),
  //       plan_start_date: moment(new Date()).format('YYYY-MM-DD'),
  //       plan_end_date: moment(new Date()).format('YYYY-MM-DD'),
  //       phase_name: null,
  //       name: null,
  //       completed_percent: null
  //     },
  //     plan: plan,
  //     check: check
  //   })
  // }
  addTask = () => {
    let plan = this.state.addPlan
    plan.push(this.state.newTask)
    // let check = this.state.check
    // check.push(false)
    this.setState({
      add: true,
      newTask: {
        task_name: null,
        actual_start_date: moment(new Date()).format('YYYY-MM-DD'),
        actual_end_date: moment(new Date()).format('YYYY-MM-DD'),
        plan_start_date: moment(new Date()).format('YYYY-MM-DD'),
        plan_end_date: moment(new Date()).format('YYYY-MM-DD'),
        phase_name: null,
        name: null,
        completed_percent: null
      },
      addPlan: plan
      // check: check
    })
  }
  cancelActionPlann = () => {
    this.setState({
      add: false,
      edit: false,
      addPlan: []
    })
  }
  saveActionPlann = () => {
    if (this.state.add) {
      let plan = this.state.plan
      let addPlan = this.state.addPlan
      let check = []
      let newPlan = plan.concat(addPlan)
      let savePlan = plan.concat(addPlan)
      savePlan = savePlan.map(item => {
        let task = item
        check.push(false)
        return {
          ...task,
          emp_detail_id: item.name?.value || null
        }
      })
      savePlan = savePlan.map(item => {
        let task = item
        delete task.name
        return task
      })
      let data = {
        result_id: this.props?.resultId,
        result_item_id: this.props?.resultItemId,
        plan: savePlan
      }
      this.setState({
        plan: newPlan,
        addPlan: [],
        check: check,
        add: false
      })
      this.props.createActionPlan(data)
    } else if (this.state.edit) {
      let plan = [...this.state.editPlan]
      let savePlan = [...this.state.editPlan]
      savePlan = savePlan.map(item => {
        let task = item
        return {
          ...task,
          emp_detail_id: item.name?.value || null
        }
      })
      savePlan = savePlan.map(item => {
        let task = item
        delete task.name
        return task
      })
      let data = {
        result_id: this.props?.resultId,
        result_item_id: this.props?.resultItemId,
        plan: savePlan
      }
      this.props.createActionPlan(data)
      this.setState({
        plan: plan,
        edit: false
      })
    } else {
      let plan = this.state.plan
      plan = plan.map(item => {
        let task = item
        return {
          ...task,
          emp_detail_id: item.name?.value || null
        }
      })
      plan = plan.map(item => {
        let task = item
        delete task.name
        return task
      })
      let data = {
        result_id: this.props?.resultId,
        result_item_id: this.props?.resultItemId,
        plan: plan
      }
      this.props.createActionPlan(data)
    }
  }
  gantt = () => {
    let rows = {}
    let items = {}
    let index = 0
    this.state.plan.map((item, i) => {
      rows = {
        ...rows,
        [i + i]: {
          id: i + i,
          label: item.task_name,
          responsible: item.name?.name,
          progress: item.completed_percent,
          // style: { background: '#7edc1a' }
          style: {
            current: { background: i % 2 === 0 ? '#EBEDEF' : '#D6DBDF' },
            // children: { background: 'lightgray' },
            grid: {
              block: {
                current: { background: i % 2 === 0 ? '#EBEDEF' : '#D6DBDF' }
                // children: { background: 'lightgray' }
              }
            }
          }
        },
        [i + i + 1]: {
          id: i + i + 1,
          label: '',
          responsible: item.name?.position_name,
          progress: '',
          // style: { background: '#7edc1a' }
          style: {
            current: { background: i % 2 === 0 ? '#EBEDEF' : '#D6DBDF' },
            // children: { background: 'lightgray' },
            grid: {
              block: {
                current: { background: i % 2 === 0 ? '#EBEDEF' : '#D6DBDF' }
                // children: { background: 'lightgray' }
              }
            }
          }
        }
      }

      items = {
        ...items,
        [index]: {
          id: index,
          rowId: i + i,
          label: '',
          time: {
            start: new Date(item.plan_start_date).getTime(),
            end: new Date(item.plan_end_date).getTime()
          },
          style: { background: '#1A90DC' }
        },
        [index + 1]: {
          id: index + 1,
          rowId: i + i + 1,
          label: '',
          time: {
            start: new Date(item.plan_end_date).getTime(),
            end: new Date(item.actual_end_date).getTime()
          },
          style: { background: '#EC361D' }
        },
        [index + 2]: {
          id: index + 2,
          rowId: i + i + 1,
          label: '',
          time: {
            start: new Date(item.actual_start_date).getTime(),
            end: new Date(item.plan_end_date).getTime()
          },
          style: { background: '#7edc1a' }
        }
      }
      index = index + 3
      return item
    })
    let gantt = { rows, items }
    this.props.setGantt(gantt)
    this.setState({ gantt: gantt })
  }
  checked = i => {
    let check = this.state.check
    check[i] = !check[i]
    this.setState({
      check: check
    })
  }
  delTask = () => {
    let plan = this.state.plan
    let check = this.state.check
    plan = plan.filter((item, i) => {
      return !check[i]
    })
    check = plan.map(() => false)
    this.setState({
      plan: plan,
      check: check
    })
  }
  editt = () => {
    let plan = [...this.state.plan]
    this.setState({
      edit: true,
      editPlan: plan
    })
  }
  render() {
    let form = null
    if (this.props.loadingRes || this.props.loadingPlan) {
      form = <Spinner />
    } else {
      form = (
        <div>
          <Grid container spacing={3} direction='column' justify='space-around'>
            <Grid xs={12} item style={{ backgroundColor: '#ffffe8' }}>
              <Grid container spacing={2} justify='space-between'>
                <Grid item>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        // clicked={() => this.setState({ add: !this.state.add })}
                        clicked={() => this.addTask()}
                        disabled={this.state.edit}
                        btnColor={'success'}>
                        {this.props.translate('add')}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        clicked={() => this.editt()}
                        disabled={this.state.add || this.state.edit}
                        btnColor={'warning'}>
                        {this.props.translate('edit')}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        clicked={() => this.delTask()}
                        btnColor={'danger'}
                        disabled={!this.state.check.find(item => item === true)}>
                        {this.props.translate('delete')}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Button
                        btnColor={'primary'}
                        clicked={() => this.saveActionPlann()}
                        disabled={this.validateSave()}>
                        {this.props.translate('save')}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button clicked={() => this.cancelActionPlann()} btnColor={'danger'}>
                        {this.props.translate('cancel')}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {this.validateSave() ? (
              <Grid xs={12} item style={{ color: 'red' }}>
                *{this.props.translate('taskNameIsRequired')}
              </Grid>
            ) : null}
            <Grid xs={12} item>
              <TableContainer>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      {this.state.edit || this.state.add ? null : (
                        <TableCell align='center'>{this.props.translate('select')}</TableCell>
                      )}
                      <TableCell align='right' width='8%'>
                        {this.props.translate('task')}
                      </TableCell>
                      <TableCell align='right'>{this.props.translate('planStart')}</TableCell>
                      <TableCell align='right'>{this.props.translate('planEnd')}</TableCell>
                      <TableCell align='right'>{this.props.translate('actualStart')}</TableCell>
                      <TableCell align='right'>{this.props.translate('actualEnd')}</TableCell>
                      <TableCell align='right'>{this.props.translate('phase')}</TableCell>
                      <TableCell align='right' width='18%'>
                        {this.props.translate('responsible')}
                      </TableCell>
                      <TableCell align='right'>%{this.props.translate('achievement')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.plan && this.state.plan.length > 0
                      ? !this.state.edit
                        ? this.state.plan.map((r, i) => (
                            <TableRow key={i}>
                              {this.state.edit || this.state.add ? null : (
                                <TableCell align='center'>
                                  <Checkbox
                                    checked={this.state.check[i]}
                                    onChange={() => this.checked(i)}
                                    color='primary'
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                  />
                                </TableCell>
                              )}

                              <TableCell align='right'>{r.task_name}</TableCell>
                              <TableCell align='right'>{r.plan_start_date}</TableCell>
                              <TableCell align='right'>{r.plan_end_date}</TableCell>
                              <TableCell align='right'>{r.actual_start_date}</TableCell>
                              <TableCell align='right'>{r.actual_end_date}</TableCell>
                              <TableCell align='right'>{r.phase_name}</TableCell>
                              <TableCell align='right'>{r.name?.label || null}</TableCell>
                              <TableCell align='right'>{r.completed_percent}</TableCell>
                            </TableRow>
                          ))
                        : this.state.editPlan.map((row, i) => (
                            <TableRow key={i}>
                              {this.state.planTemplate.map(item =>
                                [
                                  'plan_start_date',
                                  'plan_end_date',
                                  'actual_start_date',
                                  'actual_end_date'
                                ].includes(item) ? (
                                  <TableCell align='right'>
                                    <InputGroup
                                      inputType={'datePicker'}
                                      configs={{
                                        inputProps: {
                                          style: { textAlign: 'right' }
                                        }
                                      }}
                                      changed={e => this.inputAllChanged(item, e, 'datePicker', i)}
                                      inputValue={row[item] || null}
                                    />
                                  </TableCell>
                                ) : item === 'name' ? (
                                  <TableCell align='right'>
                                    <InputGroup
                                      inputType={'newselect'}
                                      configs={{
                                        inputProps: {
                                          style: { textAlign: 'right' }
                                        },
                                        options: this.state.select
                                      }}
                                      changed={e => this.inputAllChanged(item, e, 'newselect', i)}
                                      inputValue={row[item] || null}
                                    />
                                  </TableCell>
                                ) : (
                                  <TableCell align='right'>
                                    <InputGroup
                                      inputType={'input'}
                                      configs={{
                                        inputProps: {
                                          style: { textAlign: 'right' }
                                        }
                                      }}
                                      changed={e => this.inputAllChanged(item, e, 'input', i)}
                                      inputValue={row[item] || null}
                                    />
                                  </TableCell>
                                )
                              )}
                            </TableRow>
                          ))
                      : null}
                    {/* {this.state.add ? (
                      <TableRow>
                        {this.state.planTemplate.map(item =>
                          [
                            'actual_start_date',
                            'actual_end_date',
                            'plan_start_date',
                            'plan_end_date'
                          ].includes(item) ? (
                            <TableCell align='right'>
                              <InputGroup
                                inputType={'datePicker'}
                                configs={{
                                  inputProps: {
                                    style: { textAlign: 'right' }
                                  }
                                }}
                                changed={e => this.inputChanged(item, e, 'datePicker')}
                                inputValue={this.state.newTask[item]}
                              />
                            </TableCell>
                          ) : item === 'name' ? (
                            <TableCell align='right'>
                              <InputGroup
                                inputType={'newselect'}
                                configs={{
                                  inputProps: {
                                    style: { textAlign: 'right' }
                                  },
                                  options: this.state.select
                                }}
                                changed={e => this.inputChanged(item, e, 'newselect')}
                                // inputValue={'2020-08-10'}
                              />
                            </TableCell>
                          ) : (
                            <TableCell align='right'>
                              <InputGroup
                                inputType={'input'}
                                configs={{
                                  inputProps: {
                                    style: { textAlign: 'right' }
                                  }
                                }}
                                changed={e => this.inputChanged(item, e, 'input')}
                                // inputValue={'2020-08-10'}
                              />
                            </TableCell>
                          )
                        )}
                        <TableCell align='right'>
                          <IconButton onClick={() => this.addTask()}>
                            <AddIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ) : null} */}
                    {this.state.addPlan.map((row, i) => (
                      <TableRow>
                        {this.state.planTemplate.map(item =>
                          [
                            'actual_start_date',
                            'actual_end_date',
                            'plan_start_date',
                            'plan_end_date'
                          ].includes(item) ? (
                            <TableCell align='right'>
                              <InputGroup
                                inputType={'datePicker'}
                                configs={{
                                  inputProps: {
                                    style: { textAlign: 'right' }
                                  }
                                }}
                                changed={e => this.inputAddChanged(item, e, 'datePicker', i)}
                                inputValue={row[item]}
                              />
                            </TableCell>
                          ) : item === 'name' ? (
                            <TableCell align='right'>
                              <InputGroup
                                inputType={'newselect'}
                                configs={{
                                  inputProps: {
                                    style: { textAlign: 'right' }
                                  },
                                  options: this.state.select
                                }}
                                changed={e => this.inputAddChanged(item, e, 'newselect', i)}
                                inputValue={row[item]}
                              />
                            </TableCell>
                          ) : (
                            <TableCell align='right'>
                              <InputGroup
                                inputType={'input'}
                                configs={{
                                  inputProps: {
                                    style: { textAlign: 'right' }
                                  }
                                }}
                                changed={e => this.inputAddChanged(item, e, 'input', i)}
                                inputValue={row[item]}
                              />
                            </TableCell>
                          )
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid xs={3} item>
              <Button clicked={() => this.gantt()} btnColor={'success'} endIcon={<RefreshIcon />}>
                Gantt Chart
              </Button>
            </Grid>
            <Grid xs={12} item>
              {this.props.gantt?.gantt ? (
                <Gantt
                  header={this.state.headerGantt}
                  data={this.state.gantt}
                  height={this.state.plan ? this.state.plan.length : 1}
                />
              ) : null}
            </Grid>
          </Grid>
        </div>
      )
    }

    return <div>{form}</div>
  }
}

const mapStateToProps = state => {
  return {
    //   pagination: state.criteria.pagination,
    data: state.appraisal.actionPlan,
    gantt: state.appraisal.gantt,
    actionPlan: state.appraisal.actionPlanData,
    responsible: state.appraisal.responsible,
    loadingRes: state.appraisal.loadingResponsible,
    //   appraisalTypeOptions: state.criteria.appraisalType,
    loadingPlan: state.appraisal.loadingActionPlan
    //   selectedRecord: state.criteria.selectedRecord,
    //   companyOptions: state.criteria.company,
    //   filterCriteria: state.criteria.filterCriteria,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchActionPlan: filterOptions => dispatch(actions.fetchActionPlan(filterOptions)),
    createActionPlan: filterOptions => dispatch(actions.saveActionPlan(filterOptions)),
    fetchResponsibleOptionsForAppraisal: filterOptions =>
      dispatch(actions.fetchResponsibleOptionsForAppraisal(filterOptions)),
    setGantt: data => dispatch(actions.setGantt(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ActionPlan))
